import axios from 'axios';
import api from '@/lib/axios';
import {createCompanySettingsRequests} from './companySettingsRequests.js';

const client = axios.create({baseURL:api.defaults.baseURL,withCredentials:true,timeout:60000,
  headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
export const companySettingsApi = createCompanySettingsRequests(client);
